import { useState } from 'react'
import styled from 'styled-components'

import Box from 'components/Box'
import LoadingView from 'components/LoadingView'

type Props = {
  src: string
  title?: string
}

const IframeWithLoader = ({ src, title = 'Iframe' }: Props) => {
  const [isLoading, setIsLoading] = useState(true)

  const handleIframeLoad = () => {
    setIsLoading(false)
  }

  return (
    <Box height="100%" width="100%">
      {isLoading && <LoadingView message={`Loading ${title}...`} />}
      <IFrame src={src} onLoad={handleIframeLoad} title={title} isLoading={isLoading} />
    </Box>
  )
}

const IFrame = styled.iframe<{ isLoading: boolean }>`
  width: 100%;
  height: 100%;
  border: none;
  display: ${({ isLoading }) => (isLoading ? 'none' : 'block')};
`

export default IframeWithLoader
